import { Injectable } from '@angular/core';
import { BudgetDeterminationSystem, CustomFieldDTO, ProcurementProjectDTO, RequestMaterialDTO } from '../../api/plyca-dtos-v2';
import { FormConfig, FormConfigHelper } from '../../components/forms/form.objects';
import { formatDate } from '@angular/common';
import * as  moment from 'moment';
import { PropertyService } from '../../properties/property.service';

@Injectable()
export class ProcurementProjectValidationsINECO {
  propertyService: PropertyService;



  constructor() { }


  public changeProjectCode(model: any) {
    if (model.customFields.PROYCOD_AUX) {
      if (model.customFields.PROYCOD_AUX.deputyDirectorate != null) {
        model.customFields.UNIDAD_SICI = model.customFields.PROYCOD_AUX.deputyDirectorate;
      } else {
        model.customFields.UNIDAD_SICI = model.customFields.PROYCOD_AUX.dAddress;
      }
      model.customFields.PROYSUBCON = model.customFields.PROYCOD_AUX.outsourcedPercentage;
      model.customFields.PROYPRESUP = model.customFields.PROYCOD_AUX.totalAmount;
      model.customFields.GASTOEXTERNOCOMPROMETIDO = model.customFields.PROYCOD_AUX.externalExpend;
      model.customFields.PROYFINI = model.customFields.PROYCOD_AUX.startDate;
      model.customFields.PROYFFIN = model.customFields.PROYCOD_AUX.endDate;
      if (model.customFields.PROYCOD_AUX.responsibleContract !== undefined && model.customFields.PROYCOD_AUX.responsibleContract != null) {
        model.contractInformation.contractResponsible = model.customFields.PROYCOD_AUX.responsibleContract;
      }
      model.customFields.PROYCOD = model.customFields.PROYCOD_AUX.identifier;
      let proyectAmount = model.budget.totalAmount !== undefined ? model.budget.totalAmount : model.budget.amountExcludingTaxes;
      let proysubcon =
        model.customFields.GASTOEXTERNOCOMPROMETIDO != null &&
          proyectAmount != null &&
          model.customFields.PROYPRESUP != null &&
          model.customFields.PROYPRESUP > 0 ?
          (model.customFields.GASTOEXTERNOCOMPROMETIDO + proyectAmount) / model.customFields.PROYPRESUP : 0;
      model.customFields.PROYSUBCON = proysubcon !== null && proysubcon !== undefined ? parseFloat(proysubcon.toFixed(2)) : null;
      model.customFields.PROYSUBCON = model.customFields.PROYSUBCON * 100;
    } else {
      model.customFields.PROYSUBCON = undefined;
      model.customFields.PROYPRESUP = undefined;
      model.customFields.GASTOEXTERNOCOMPROMETIDO = undefined;
      model.customFields.PROYFFIN = undefined;
      model.customFields.PROYFINI = undefined;
      model.contractInformation.contractResponsible = undefined;
      model.customFields.PROYCOD = undefined;
      model.customFields.UNIDAD_SICI = undefined;
    }
  }

  /*public changeProjectCode(model: any) {
    model.customFields.PROYSUBCON = model.customFields.PROYSUBCON;
    model.customFields.PROYPRESUP = model.customFields.PROYPRESUP
    model.customFields.PROYFFIN = model.customFields.PROYFINI;
    model.customFields.PROYFINI = model.customFields.PROYFFIN;
    model.contractInformation.contractResponsible = model.customFields.PROYCOD_AUX.responsibleContract;
    model.customFields.PROYCOD = model.customFields.PROYCOD;
  }*/

  public loadData(model: any) {
    model.customFields.PROYCOD_AUX = new CustomFieldDTO();

    if (model.customFields.PROYCOD_AUX.identifier === undefined) {
      model.customFields.PROYCOD_AUX.identifier = model.customFields.PROYCOD;
      model.customFields.PROYCOD_AUX.outsourcedPercentage = model.customFields.PROYSUBCON;
      model.customFields.PROYCOD_AUX.totalAmount = model.customFields.PROYPRESUP;
      model.customFields.PROYCOD_AUX.externalExpend = model.customFields.GASTOEXTERNOCOMPROMETIDO;
      model.customFields.PROYCOD_AUX.startDate = model.customFields.PROYFINI;
      model.customFields.PROYCOD_AUX.endDate = model.customFields.PROYFFIN;

    }
    return model.customFields.PROYCOD_AUX;

  }


}
